import { isRevampSKYCJourney } from '../constants/AppConstants';

export const closeVideoModalRevamp = (
   { args, onUserAction, additionalData, getState }: any,
   callback: any
) => {
   const { storeValues } = getState();
   const isClosedWithoutUpload = args?.[0] === 'closeWithoutUpload';
   let isSuccess;

      isSuccess = additionalData?.dataFromWidget?.response?.status === '200';
   isSuccess = isSuccess || isClosedWithoutUpload;
   console.log("closeVideoModalRevamp additionalData?.dataFromWidget?.response?.statu>>>",additionalData?.dataFromWidget?.response?.status)
   const actions: any[] = [];

   if (isSuccess) {
      callback();
      if (!isClosedWithoutUpload) {
      
            actions.push({
               type: 'navigation',
               payload: {
                  screenName: '/disability',
                  type: 'push',
                  shouldAddSearchParams: true,
                  params: {
                     screenQueryParams: {
                      
                     },
                  },
               },
            });
      
      }
   } else {
          
      onUserAction({
         actions: [
            {
               type: 'showToast',
               payload: {
                  title: 'something went wrong please try again',
                  dismissDuration: 5000,
                  position: 'bottom-center',
                  state: 'error',
                  style: {
                     zIndex: 10000,
                  },
               },
            },
         ],
      });
   }

   onUserAction({
      actions,
   });
};
